import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="relative w-full bg-gradient-to-br from-stone-50 via-[#EFFAF5] to-stone-100 overflow-hidden" data-id="element-67">
      <div className="py-24 md:py-32" data-id="element-68">
        {/* Animated background blobs */}
        <div className="absolute inset-0 overflow-hidden" data-id="element-69">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#186447]/5 rounded-full blur-3xl" data-id="element-70"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#22AC79]/5 rounded-full blur-3xl" data-id="element-71"></div>
        </div>
        <div className="container mx-auto px-6 md:px-12 max-w-7xl relative" data-id="element-72">
          <div className="grid lg:grid-cols-[60fr_40fr] gap-12 lg:gap-16 items-center" data-id="element-73">
            {/* Content Area */}
            <div className="bg-white rounded-3xl p-10 md:p-14 lg:p-16 shadow-2xl relative z-10 border border-stone-100" data-id="element-74">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-normal text-[#111928] mb-6 tracking-tight leading-[1.15]" data-id="element-75">
                <span className="text-[#186447]" data-id="element-76">Unlock new income</span>
                <br data-id="element-77" />
                <i className="font-normal" data-id="element-78">from anywhere</i>
              </h1>
              <p className="text-lg md:text-xl text-[#6B7280] mb-8 leading-relaxed max-w-xl" data-id="element-79">
                Share your expertise and love for giving aesthetics advice by
                becoming a virtual <b data-id="element-80">Glow-Up Coach</b>
              </p>
              <a href="https://calendly.com/kevin-certainly" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#186447] hover:bg-[#22AC79] text-white px-8 py-3 rounded-lg shadow-sm hover:shadow-md transition-all" data-id="element-81">
                Become a Glow-Up Coach
                <ArrowRightIcon size={20} strokeWidth={2} data-id="element-82" />
              </a>
            </div>
            {/* Image */}
            <div className="relative lg:absolute lg:right-[8%] lg:top-1/2 lg:-translate-y-1/2 lg:w-[35%]" data-id="element-83">
              <div className="rounded-xl md:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:scale-[1.02]" data-id="element-84">
                <img src="https://cdn.magicpatterns.com/uploads/9uLK71yB999Fb8dRPQnH8k/coach_hero_image.png" alt="Healthcare professional providing virtual consultation" className="w-full h-[400px] lg:h-[550px] object-contain" data-id="element-85" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};